import styled from '@emotion/styled'
import type React from 'react'
import { colors, fontWeight, spacing } from '../../foundation'

type BadgeColorOptions = 'blue' | 'grey'

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: BadgeColorOptions
}

export const Badge = styled.div<BadgeProps>((props: BadgeProps) => {
  // Default is 'blue'
  const colorStyles = (props.color && badgeColors[props.color]) || badgeColors.blue

  return {
    ...colorStyles,
    padding: '4px 8px',
    borderRadius: spacing.X12,
    fontSize: 10,
    fontWeight: fontWeight.BOLD,
    height: 'fit-content',
  }
})

const badgeColors = {
  blue: {
    backgroundColor: '#F2F8FF',
    color: colors.HIGHLIGHT.REGULAR,
  },
  grey: {
    backgroundColor: colors.GRAYSCALE.X10,
    color: colors.GRAYSCALE.X70,
  },
}
